import styled from "styled-components";
import { AppBar, Paper } from "@mui/material";
import { matjungelenAmber, matjungelenDarkGreen } from "./colors";

export const StyledPaperAmber = styled(Paper)({
    '&.MuiPaper-root': {
        background: matjungelenAmber,
        border: 'none',
        borderRadius: '24px'
    }
})


export const StyledPaperGreen = styled(Paper)({
    '&.MuiPaper-root': {
        background: matjungelenDarkGreen,
        border: 'none',
        borderRadius: '24px'
    }
})

export const StyledAppBar = styled(AppBar)({
    '&.MuiAppBar-root': {
        background: 'transparent',
        boxShadow: 'none'
    },
    '.MuiToolbar-root': {
        background: 'transparent',
        height: '83px'
    }
})
